import { Injectable } from '@angular/core';








import { GlobalHttpClient } from '../global.http.client';
import { BaseService } from './base.service';
import { Configuration } from '../configuration';
import { LoggedInUserService } from '../auth/logged.in.user';
import { AddTenderTeamMemberDto, DeleteTenderTeamMemberDto, SetTenderTeamMemberFileAccessDto } from '../models/tender.team.members/tender.team.member.models';

@Injectable()
export class TenderTeamMemberService extends BaseService {
    constructor(http: GlobalHttpClient, private readonly config: Configuration, private loggedInUserService: LoggedInUserService) {
        super(http);
    }

    add(dto: AddTenderTeamMemberDto) {
        return this.http.post('tenderTeamMembers', dto);
    }

    setFileAccess(dto: SetTenderTeamMemberFileAccessDto) {
        return this.http.post('tenderTeamMembers/setFileAccess', dto);
    }

    remove(dto: DeleteTenderTeamMemberDto) {
        return this.http.deleteWithParams('tenderTeamMembers', dto);
    }

    resendInvitation(id: number) {
        return this.http.get(`tenderTeamMembers/resendInvitation/${id}`);
    }

    getAll() {
        return this.http.get('tenderTeamMembers');
    }

    getMaxTeamMembers() {
        return this.http.get('tenderTeamMembers/max');
    }

    delete(id: number, rowVersion: string) {
        return this.http.deleteWithParams('tenderTeamMembers', { id: id, rowVersion: rowVersion });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/tender.team.member.service.ts